/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  USER_UPSERT_REQUEST,
  USER_UPSERT_REQUEST_SUCCESS,
  USER_UPSERT_REQUEST_FAILURE,
  USER_FETCH_REQUEST,
  USER_FETCH_REQUEST_SUCCESS,
  USER_FETCH_REQUEST_FAILURE,
  CHANGE_USER_PASSWORD_REQUEST,
  CHANGE_USER_PASSWORD_REQUEST_SUCCESS,
  CHANGE_USER_PASSWORD_REQUEST_FAILURE,
  USER_CLEAN_REQUEST,
  USER_DROPDOWN_CLIENT_REQUEST,
  ALL_USER_FETCH_REQUEST,
  ALL_USER_FETCH_REQUEST_SUCCESS,
  ALL_USER_FETCH_REQUEST_FAILURE,
  USER_SERVICES_ADD_REQUEST,
  USER_SERVICES_ADD_REQUEST_SUCCESS,
  USER_SERVICES_ADD_REQUEST_FAILURE,
  USER_SERVICES_FETCH_REQUEST,
  USER_SERVICES_FETCH_REQUEST_SUCCESS,
  USER_SERVICES_FETCH_REQUEST_FAILURE,
  USER_UPSERT_WORKING_HOUR_REQUEST,
  USER_UPSERT_WORKING_HOUR_REQUEST_SUCCESS,
  USER_UPSERT_WORKING_HOUR_REQUEST_FAILURE,
  USER_FETCH_WORKING_HOUR_REQUEST,
  USER_FETCH_WORKING_HOUR_REQUEST_SUCCESS,
  USER_FETCH_WORKING_HOUR_REQUEST_FAILURE,
  USER_UPSERT_BREAK_REQUEST,
  USER_UPSERT_BREAK_REQUEST_SUCCESS,
  USER_UPSERT_BREAK_REQUEST_FAILURE,
  USER_FETCH_BREAK_REQUEST,
  USER_FETCH_BREAK_REQUEST_SUCCESS,
  USER_FETCH_BREAK_REQUEST_FAILURE,
  USER_UPSERT_TIME_OFF_REQUEST,
  USER_UPSERT_TIME_OFF_REQUEST_SUCCESS,
  USER_UPSERT_TIME_OFF_REQUEST_FAILURE,
  USER_FETCH_TIME_OFF_REQUEST,
  USER_FETCH_TIME_OFF_REQUEST_SUCCESS,
  USER_FETCH_TIME_OFF_REQUEST_FAILURE,
  USER_APPOINTMENT_POLICY_FETCH_REQUEST,
  USER_APPOINTMENT_POLICY_FETCH_REQUEST_SUCCESS,
  USER_APPOINTMENT_POLICY_FETCH_REQUEST_FAILURE,
  USER_APPOINTMENT_POLICY_UPSERT_REQUEST,
  USER_APPOINTMENT_POLICY_UPSERT_REQUEST_SUCCESS,
  USER_APPOINTMENT_POLICY_UPSERT_REQUEST_FAILURE,
  USER_TAB_PROPS_CLEAN_REQUEST,
  USER_CHECK_TIME_OFF_REQUEST,
  USER_CHECK_TIME_OFF_REQUEST_SUCCESS,
  USER_CHECK_TIME_OFF_REQUEST_FAILURE,
  USER_CHECK_TIME_OFF_CLEAN_REQUEST,
  TAX_REPRESENTATIVE_FETCH_REQUEST,
  TAX_REPRESENTATIVE_FETCH_REQUEST_SUCCESS,
  TAX_REPRESENTATIVE_FETCH_REQUEST_FAILURE,
  USER_PREFERENCE_FETCH_REQUEST,
  USER_PREFERENCE_FETCH_REQUEST_SUCCESS,
  USER_PREFERENCE_FETCH_REQUEST_FAILURE,
  USE_PREFERENCE_CLEAN_REQUEST,
  USER_MEMBERS_FETCH_REQUEST,
  USER_MEMBERS_FETCH_REQUEST_SUCCESS,
  USER_MEMBERS_FETCH_REQUEST_FAILURE,
  USER_MEMBERS_LINK_REQUEST,
  USER_MEMBERS_LINK_REQUEST_SUCCESS,
  USER_MEMBERS_LINK_REQUEST_FAILURE,
  SWITCHABLE_PROFILES_FETCH_REQUEST,
  SWITCHABLE_PROFILES_FETCH_REQUEST_SUCCESS,
  SWITCHABLE_PROFILES_FETCH_REQUEST_FAILURE,
  SWITCH_MEMBER_PROFILE_REQUEST,
  SWITCH_MEMBER_PROFILE_REQUEST_SUCCESS,
  SWITCH_MEMBER_PROFILE_REQUEST_FAILURE,
  CLEAN_USER_MEMBERS_LINK_PROPS,
  USER_TAB_ERROR_PROPS_CLEAN_REQUEST,
  TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST,
  TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST_SUCCESS,
  TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  payloadAll: [],
  loadingAll: false,
  errorsAll: {},
  userServicesPayload: [],
  userServicesLoading: false,
  userServicesErrors: {},
  addUserServicesPayload: [],
  addUserServicesLoading: false,
  addUserServicesErrors: {},
  updateWorkingHourPayload: [],
  updateWorkingHourLoading: false,
  updateWorkingHourErrors: {},
  userWorkingHourPayload: [],
  userWorkingHourLoading: false,
  userWorkingHourErrors: {},
  updateBreakPayload: [],
  updateBreakLoading: false,
  updateBreakErrors: {},
  userBreakPayload: [],
  userBreakLoading: false,
  userBreakErrors: {},
  updateTimeOffPayload: [],
  updateTimeOffLoading: false,
  updateTimeOffErrors: {},
  userTimeOffPayload: [],
  userTimeOffLoading: false,
  userTimeOffErrors: {},
  policyPayload: [],
  policyLoading: false,
  policyErrors: {},
  policyUpdatePayload: [],
  policyUpdateLoading: false,
  policyUpdateErrors: {},
  userTimeOffCheckerPayload: [],
  userTimeOffCheckerLoading: false,
  userTimeOffCheckerErrors: {},
  taxRepresentativeDropdown: [],
  taxRepresentativeDropdownLoading: false,
  taxRepresentativeUpdate: [],
  taxRepresentativeUpdateLoading: false,
  taxRepresentativeUpdateErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const userReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case ALL_USER_FETCH_REQUEST:
      return Object.assign({}, state, {
        loadingAll: true,
      });

    case ALL_USER_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payloadAll: action.data,
        loadingAll: false,
        errorsAll: {},
      });

    case ALL_USER_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loadingAll: false,
        errorsAll: action.error,
      });

    case TAX_REPRESENTATIVE_FETCH_REQUEST:
      return Object.assign({}, state, {
        taxRepresentativeDropdownLoading: true,
      });

    case TAX_REPRESENTATIVE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taxRepresentativeDropdown: action.data,
        taxRepresentativeDropdownLoading: false,
        taxRepresentativeDropdownErrors: {},
      });

    case TAX_REPRESENTATIVE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taxRepresentativeDropdownLoading: false,
        taxRepresentativeDropdownErrors: action.error,
      });

    case USER_UPSERT_REQUEST:
    case USER_FETCH_REQUEST:
    case CHANGE_USER_PASSWORD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CHANGE_USER_PASSWORD_REQUEST_SUCCESS:
    case USER_UPSERT_REQUEST_SUCCESS:
    case USER_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data?.currentPage,
          pageSize: action.data?.limit,
          total: action.data?.totalRecords,
          totalPage: action.data?.totalRecords
            ? Math.round(action.data.totalRecords / action.data.limit) +
              (Math.abs(action.data.totalRecords / action.data.limit) >
              Math.round(action.data.totalRecords / action.data.limit)
                ? 1
                : 0)
            : 0,
          showSizeChanger: true,
        },
      });

    case CHANGE_USER_PASSWORD_REQUEST_FAILURE:
    case USER_UPSERT_REQUEST_FAILURE:
    case USER_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case USER_SERVICES_ADD_REQUEST:
      return Object.assign({}, state, {
        addUserServicesLoading: true,
      });

    case USER_SERVICES_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        addUserServicesLoading: false,
        addUserServicesPayload: action.data,
        addUserServicesErrors: {},
      });

    case USER_SERVICES_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        addUserServicesLoading: false,
        addUserServicesErrors: action.error,
      });

    case USER_SERVICES_FETCH_REQUEST:
      return Object.assign({}, state, {
        userServicesLoading: true,
      });

    case USER_SERVICES_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        userServicesLoading: false,
        userServicesPayload: action.data,
        userServicesErrors: {},
      });

    case USER_SERVICES_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        userServicesLoading: false,
        userServicesErrors: action.error,
      });

    case USER_UPSERT_WORKING_HOUR_REQUEST:
      return Object.assign({}, state, {
        updateWorkingHourLoading: true,
      });

    case USER_UPSERT_WORKING_HOUR_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        updateWorkingHourLoading: false,
        updateWorkingHourPayload: action.data,
        updateWorkingHourErrors: {},
      });

    case USER_UPSERT_WORKING_HOUR_REQUEST_FAILURE:
      return Object.assign({}, state, {
        updateWorkingHourLoading: false,
        updateWorkingHourErrors: action.error,
      });

    case USER_FETCH_WORKING_HOUR_REQUEST:
      return Object.assign({}, state, {
        userWorkingHourLoading: true,
      });

    case USER_FETCH_WORKING_HOUR_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        userWorkingHourLoading: false,
        userWorkingHourPayload: action.data,
        userWorkingHourErrors: {},
      });

    case USER_FETCH_WORKING_HOUR_REQUEST_FAILURE:
      return Object.assign({}, state, {
        userWorkingHourLoading: false,
        userWorkingHourErrors: action.error,
      });

    case USER_UPSERT_BREAK_REQUEST:
      return Object.assign({}, state, {
        updateBreakLoading: true,
      });

    case USER_UPSERT_BREAK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        updateBreakLoading: false,
        updateBreakPayload: action.data,
        updateBreakErrors: {},
      });

    case USER_UPSERT_BREAK_REQUEST_FAILURE:
      return Object.assign({}, state, {
        updateBreakLoading: false,
        updateBreakErrors: action.error,
      });

    case USER_FETCH_BREAK_REQUEST:
      return Object.assign({}, state, {
        userBreakLoading: true,
      });

    case USER_FETCH_BREAK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        userBreakLoading: false,
        userBreakPayload: action.data,
        userBreakErrors: {},
      });

    case USER_FETCH_BREAK_REQUEST_FAILURE:
      return Object.assign({}, state, {
        userBreakLoading: false,
        userBreakErrors: action.error,
      });

    case USER_UPSERT_TIME_OFF_REQUEST:
      return Object.assign({}, state, {
        updateTimeOffLoading: true,
      });

    case USER_UPSERT_TIME_OFF_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        updateTimeOffLoading: false,
        updateTimeOffPayload: action.data,
        updateTimeOffErrors: {},
      });

    case USER_UPSERT_TIME_OFF_REQUEST_FAILURE:
      return Object.assign({}, state, {
        updateTimeOffLoading: false,
        updateTimeOffErrors: action.error,
      });

    case USER_FETCH_TIME_OFF_REQUEST:
      return Object.assign({}, state, {
        userTimeOffLoading: true,
      });

    case USER_FETCH_TIME_OFF_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        userTimeOffLoading: false,
        userTimeOffPayload: action.data,
        userTimeOffErrors: {},
      });

    case USER_FETCH_TIME_OFF_REQUEST_FAILURE:
      return Object.assign({}, state, {
        userTimeOffLoading: false,
        userTimeOffErrors: action.error,
      });

    case USER_APPOINTMENT_POLICY_UPSERT_REQUEST:
      return Object.assign({}, state, {
        policyUpdateLoading: true,
      });

    case USER_APPOINTMENT_POLICY_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        policyUpdateLoading: false,
        policyUpdatePayload: action.data,
        policyUpdateErrors: {},
      });

    case USER_APPOINTMENT_POLICY_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        policyUpdateLoading: false,
        policyUpdateErrors: action.error,
      });

    case USER_APPOINTMENT_POLICY_FETCH_REQUEST:
      return Object.assign({}, state, {
        policyLoading: true,
      });

    case USER_APPOINTMENT_POLICY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        policyLoading: false,
        policyPayload: action.data,
        policyErrors: {},
      });

    case USER_APPOINTMENT_POLICY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        policyLoading: false,
        policyErrors: action.error,
      });

    case USER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    case USER_CHECK_TIME_OFF_REQUEST:
      return Object.assign({}, state, {
        userTimeOffCheckerLoading: true,
      });

    case USER_CHECK_TIME_OFF_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        userTimeOffCheckerLoading: false,
        userTimeOffCheckerPayload: action.data,
        userTimeOffCheckerErrors: {},
      });

    case USER_CHECK_TIME_OFF_REQUEST_FAILURE:
      return Object.assign({}, state, {
        userTimeOffCheckerLoading: false,
        userTimeOffCheckerErrors: action.error,
      });

    case USER_CHECK_TIME_OFF_CLEAN_REQUEST:
      return Object.assign({}, state, {
        userTimeOffCheckerLoading: false,
        userTimeOffCheckerPayload: [],
        userTimeOffCheckerErrors: {},
      });

    case USER_TAB_PROPS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        userServicesPayload: [],
        userServicesLoading: false,
        addUserServicesPayload: [],
        addUserServicesLoading: false,
        updateWorkingHourPayload: [],
        updateWorkingHourLoading: false,
        userWorkingHourPayload: [],
        userWorkingHourLoading: false,
        updateBreakPayload: [],
        updateBreakLoading: false,
        userBreakPayload: [],
        userBreakLoading: false,
        updateTimeOffPayload: [],
        updateTimeOffLoading: false,
        userTimeOffPayload: [],
        userTimeOffLoading: false,
        policyPayload: [],
        policyLoading: false,
        policyUpdatePayload: [],
        policyUpdateLoading: false,
      });

    case USER_TAB_ERROR_PROPS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        errors: {},
        userServicesErrors: {},
        addUserServicesErrors: {},
        updateWorkingHourErrors: {},
        userWorkingHourErrors: {},
        updateBreakErrors: {},
        userBreakErrors: {},
        updateTimeOffErrors: {},
        userTimeOffErrors: {},
        policyErrors: {},
        policyUpdateErrors: {},
      });

    case USER_DROPDOWN_CLIENT_REQUEST:
      return Object.assign({}, state, {
        payloadAll: [],
        loadingAll: false,
        errorsAll: {},
      });

    case TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST:
      return Object.assign({}, state, {
        taxRepresentativeUpdateLoading: true,
      });

    case TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taxRepresentativeUpdateLoading: false,
        taxRepresentativeUpdate: action.data,
        taxRepresentativeUpdateErrors: {},
      });

    case TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taxRepresentativeUpdateLoading: false,
        taxRepresentativeUpdateErrors: action.error,
      });
    default:
      return state;
  }
};

const INITIAL_PREFERENCE_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

export const userPreferenceReducer = (state, action) => {
  state = state || INITIAL_PREFERENCE_STATE;

  switch (action.type) {
    case USER_PREFERENCE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case USER_PREFERENCE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action?.data,
        loading: false,
      });

    case USER_PREFERENCE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action?.error,
      });

    case USE_PREFERENCE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

const INITIAL_MEMBERS_STATE = {
  payload: [],
  loading: false,
  errors: {},
  memberLink: [],
  memberLinkLoading: false,
  memberLinkErrors: {},
  switchProfile: [],
  switchProfileLoading: false,
  switchProfileErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */

export const membersReducer = (state, action) => {
  state = state || INITIAL_MEMBERS_STATE;

  switch (action.type) {
    case USER_MEMBERS_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case USER_MEMBERS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case USER_MEMBERS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SWITCHABLE_PROFILES_FETCH_REQUEST:
      return Object.assign({}, state, {
        profilesLoading: true,
      });

    case SWITCHABLE_PROFILES_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        profilesPayload: action.data,
        profilesLoading: false,
        profilesErrors: {},
      });

    case SWITCHABLE_PROFILES_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        profilesLoading: false,
        profilesErrors: action.error,
      });

    case USER_MEMBERS_LINK_REQUEST:
      return Object.assign({}, state, {
        memberLinkLoading: true,
      });
    case USER_MEMBERS_LINK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        memberLink: action.data,
        memberLinkLoading: false,
        memberLinkErrors: {},
      });
    case USER_MEMBERS_LINK_REQUEST_FAILURE:
      return Object.assign({}, state, {
        memberLinkLoading: false,
        memberLinkErrors: action.error,
      });

    case CLEAN_USER_MEMBERS_LINK_PROPS:
      return Object.assign({}, state, {
        memberLink: [],
        memberLinkLoading: false,
        memberLinkErrors: {},
      });

    case SWITCH_MEMBER_PROFILE_REQUEST:
      return Object.assign({}, state, {
        switchProfileLoading: true,
      });

    case SWITCH_MEMBER_PROFILE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        switchProfile: action.data,
        switchProfileLoading: false,
        switchProfileErrors: {},
      });

    case SWITCH_MEMBER_PROFILE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        switchProfileLoading: false,
        switchProfileErrors: action.error,
      });
    default:
      return state;
  }
};

export default userReducer;
